import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'

interface TextProps {
  languageIndex: number
}

const Text: React.FC<TextProps> = (props) => {
  const { languageIndex } = props
  const { t } = useTranslation()
  const { control } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchPlaceholder = useWatch({ control, name: `languages[${languageIndex}].placeholder` })
  const watchReq = useWatch({ control, name: 'required' })

  function renderForm() {
    return <>
      <FormFields.TextArea
        control={control}
        label={t('Type in your question')}
        placeholder={t('Type in your question')}
        name={`languages[${languageIndex}].question`}
        rules={{
          required: {
            value: true,
            message: t('Please enter question')
          }
        }}
      />
      <FormFields.Input
        control={control}
        label={t('Placeholder')}
        placeholder={t('Placeholder')}
        name={`languages[${languageIndex}].placeholder`}
      />
    </>
  }

  function renderPreview() {
    return <QuestionPreview>
      <Form.Input
        placeholder={watchPlaceholder}
        label={<div style={{ display: 'flex' }}>
          <div style={{ marginBottom: '1em' }}>{watchQuestions}</div>
          {Boolean(watchReq) && <span style={{ color: 'red' }}>*</span>}
        </div>}
      />
    </QuestionPreview>
  }

  return <>
    {renderForm()}
    {renderPreview()}
  </>
}
export default Text